import { Close, Done, ErrorOutlineOutlined } from '@mui/icons-material'
import { Box } from '@mui/material'

interface PasswordValidationProps {
  passwordString: string
}

const PasswordValidation: React.FC<PasswordValidationProps> = ({ passwordString }) => {
  const letraMinusculaRegex: RegExp = /[a-z]/
  const letraMaiusculaRegex: RegExp = /[A-Z]/
  const umNumeroRegex: RegExp = /\d/
  const caracterEspcial: RegExp = /[!@#$%^&*(),.?":{}|<>]/

  return (
    <Box
      width='100%'
      height='180px'
      zIndex='1'
      display='flex'
      alignItems='flex-start'
      justifyContent='center'
      flexDirection='column'
      padding='0.25rem'
      gap='8px'
    >
      <Box>
        <span>A senha deve conter pelo menos</span>
      </Box>
      <Box>
        <Box
          display='flex'
          gap='8px'
          sx={{
            color: passwordString.length <= 0 ? 'black' : letraMinusculaRegex.test(passwordString) ? 'green' : 'red',
          }}
        >
          {passwordString.length <= 0 ? (
            <ErrorOutlineOutlined />
          ) : letraMinusculaRegex.test(passwordString) ? (
            <Done color='success' />
          ) : (
            <Close color='error' />
          )}
          <span>Um caractere minúsculo</span>
        </Box>

        <Box
          display='flex'
          gap='8px'
          sx={{
            color: passwordString.length <= 0 ? 'black' : letraMaiusculaRegex.test(passwordString) ? 'green' : 'red',
          }}
        >
          {passwordString.length <= 0 ? (
            <ErrorOutlineOutlined />
          ) : letraMaiusculaRegex.test(passwordString) ? (
            <Done color='success' />
          ) : (
            <Close color='error' />
          )}
          <span>Um caractere maiúsculo</span>
        </Box>

        <Box
          display='flex'
          gap='8px'
          sx={{
            color: passwordString.length <= 0 ? 'black' : umNumeroRegex.test(passwordString) ? 'green' : 'red',
          }}
        >
          {passwordString.length <= 0 ? (
            <ErrorOutlineOutlined />
          ) : umNumeroRegex.test(passwordString) ? (
            <Done color='success' />
          ) : (
            <Close color='error' />
          )}
          <span>Um número</span>
        </Box>

        <Box
          display='flex'
          gap='8px'
          sx={{
            color: passwordString.length <= 0 ? 'black' : caracterEspcial.test(passwordString) ? 'green' : 'red',
          }}
        >
          {passwordString.length <= 0 ? (
            <ErrorOutlineOutlined />
          ) : caracterEspcial.test(passwordString) ? (
            <Done color='success' />
          ) : (
            <Close color='error' />
          )}
          <span>Um caractere especial</span>
        </Box>

        <Box
          display='flex'
          gap='8px'
          sx={{
            color: passwordString.length <= 0 ? 'black' : passwordString.length >= 8 ? 'green' : 'red',
          }}
        >
          {passwordString.length <= 0 ? (
            <ErrorOutlineOutlined />
          ) : passwordString.length >= 8 ? (
            <Done color='success' />
          ) : (
            <Close color='error' />
          )}
          <span>Mínimo de 8 caracteres</span>
        </Box>
      </Box>
    </Box>
  )
}

export default PasswordValidation
